import type { Component } from 'vue';
import StoryblokBanner from './components/StoryblokBanner.vue';
import StoryblokButton from './components/StoryblokButton.vue';
import StoryblokCard from './components/StoryblokCard.vue';
import StoryblokCarousel from './components/StoryblokCarousel.vue';
import StoryblokCarouselItem from './components/StoryblokCarouselItem.vue';
import StoryblokFaq from './components/StoryblokFaq.vue';
import StoryblokFaqEntry from './components/StoryblokFaqEntry.vue';
import StoryblokGrid from './components/StoryblokGrid.vue';
import StoryblokImage from './components/StoryblokImage.vue';
import StoryblokInformationPage from './components/StoryblokInformationPage.vue';
import StoryblokPage from './components/StoryblokPage.vue';
import StoryblokPageHeader from './components/StoryblokPageHeader.vue';
import StoryblokRichText from './components/StoryblokRichText.vue';
import StoryblokSection from './components/StoryblokSection.vue';
import StoryblokSectionItem from './components/StoryblokSectionItem.vue';
import StoryblokTextIllustrated from './components/StoryblokTextIllustrated.vue';
import StoryblokTitle from './components/StoryblokTitle.vue';
import StoryblokVideo from './components/StoryblokVideo.vue';

export const storyblokComponents: Record<string, Component> = {
  banner: StoryblokBanner,
  button: StoryblokButton,
  card: StoryblokCard,
  carousel: StoryblokCarousel,
  'carousel-item': StoryblokCarouselItem,
  'cards-carousel': StoryblokCarousel,
  faq: StoryblokFaq,
  'faq-entry': StoryblokFaqEntry,
  feature: StoryblokCard,
  grid: StoryblokGrid,
  image: StoryblokImage,
  'information-page': StoryblokInformationPage,
  page: StoryblokPage,
  'page-header': StoryblokPageHeader,
  richtext: StoryblokRichText,
  section: StoryblokSection,
  'section-item': StoryblokSectionItem,
  'text-illustrated': StoryblokTextIllustrated,
  title: StoryblokTitle,
  video: StoryblokVideo,
  'embed-video': StoryblokVideo,
  'video-block': StoryblokVideo,
};
